// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"8c3be68c29bd141cf7de","263":"4f7c165c48beec2fc34d","791":"aa675b2114a90e9d6cb1"}[chunkId] + ".js";
};